module.exports = __webpack_public_path__ + "img/product-shot_01.dea8e3e6.jpg";